<button type="button" class="notification-item" [class.notification-item--unread]="isUnread" (click)="handleClick()">
  <span class="notification-item__icon">
    <i class="pi" [ngClass]="icon"></i>
  </span>

  <span class="notification-item__content">
    <span class="notification-item__header">
      <span class="notification-item__category">{{ categoryLabel }}</span>
      <span class="notification-item__time">
        {{ notification.created_at | relativeTime }}
      </span>
    </span>

    <span class="notification-item__title">{{ notification.title }}</span>

    @if (notification.message) {
      <span class="notification-item__message">{{ notification.message }}</span>
    }
  </span>

  @if (isUnread) {
    <span class="notification-item__dot" aria-label="Não lida"></span>
  }
</button>
